/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Text, VFlow } from 'bold-ui'
import { ParteBucalEnum } from 'graphql/types.generated'
import { Fragment, useState } from 'react'

import { Arcadas } from '../../odontograma/Arcadas'
import OdontogramaPopper from '../components/OdontogramaPopper'
import { convertArcadasFieldModelToArcadasModel } from '../converter'
import { getParteBucal } from '../util'
import { ArcadaFieldModel } from './ArcadasField'

interface ArcadaActive {
  parteBucalEnum: ParteBucalEnum
  ref: HTMLButtonElement
  value: ArcadaFieldModel
}

export interface ArcadasViewProps {
  proteseTotalSuperior?: boolean
  proteseTotalInferior?: boolean
  value?: Record<ParteBucalEnum, ArcadaFieldModel>
}

export default function ArcadasView(props: ArcadasViewProps) {
  const { proteseTotalSuperior, proteseTotalInferior, value } = props
  const [popperOpen, setPopperOpen] = useState(false)
  const [activeArcada, setActiveArcada] = useState<ArcadaActive>()

  const onClick = (arcada: ParteBucalEnum, ref: HTMLButtonElement) => {
    setActiveArcada({ parteBucalEnum: arcada, ref, value: value && value[arcada] })
    setPopperOpen(true)
  }

  const handleClose = () => {
    setActiveArcada(undefined)
    setPopperOpen(false)
  }

  return (
    <Fragment>
      <Arcadas
        onClick={onClick}
        activeItem={activeArcada?.parteBucalEnum}
        proteseTotalSuperior={proteseTotalSuperior}
        proteseTotalInferior={proteseTotalInferior}
        value={value && convertArcadasFieldModelToArcadasModel(value)}
      />

      {activeArcada && (
        <OdontogramaPopper
          open={popperOpen}
          width={19.75}
          title={getParteBucal(activeArcada?.parteBucalEnum).title}
          placement='top'
          anchorRef={activeArcada.ref}
          onClose={handleClose}
        >
          {!activeArcada.value?.procedimentos?.length ? (
            <Text>Nenhum procedimento registrado.</Text>
          ) : (
            <VFlow>
              {activeArcada.value.procedimentos?.length && (
                <VFlow vSpacing={0.5}>
                  <Text fontWeight='bold'>Procedimentos</Text>
                  <VFlow vSpacing={0}>
                    {activeArcada.value.procedimentos.map((procedimento, key) => (
                      <Text key={key}>{procedimento.descricao}</Text>
                    ))}
                  </VFlow>
                </VFlow>
              )}

              {!!activeArcada.value.observacoes?.filter((i) => !!i).length && (
                <VFlow vSpacing={0.5}>
                  <Text fontWeight='bold'>Observações</Text>

                  <VFlow vSpacing={0}>
                    {activeArcada.value.observacoes.map((observacao, key) => (
                      <Text key={key} dangerouslySetInnerHTML={{ __html: observacao }} />
                    ))}
                  </VFlow>
                </VFlow>
              )}
            </VFlow>
          )}
        </OdontogramaPopper>
      )}
    </Fragment>
  )
}
